import { recItem } from './items.js';
import { tabGroup } from './tab_group.js';

export function getArchiveManager(data) {

	const manager = {
		posts: [],
		query: data.query,
		num_posts: data.num_posts,
		visible_posts: data.posts.length,
		posts_per_page: data.posts.length,
		loading: false,
		get has_more_items() {
			return this.posts.length < this.num_posts;
		},
		load_items() {
			if (this.has_more_items) {
				const url = `${ARGONAUT.rest_url}argonaut/v1/paging/${this.query}/${this.posts.length}/${this.posts_per_page}`;
				this.loading = true;
				fetch(url)
					.then((response) => response.json())
					.then((json) => {
						this.posts = this.posts.concat(json.posts.map(digest_item));
						this.loading = false;
					});
			}
		},
	}

	function digest_item(item) {
		return item.type === 'rec' ? recItem(item, manager) : item;
	}

	manager.posts = data.posts.map(digest_item);

	Object.assign(manager, tabGroup());

	return manager;
}